<template>
    <div class="invoice-box">
        <div class="back-btn" @click="() => this.$router.push('/profile')"> &lt; 返回 </div>
        <div class="user">
            <div class="user-title">发票信息</div>
            <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-position="top" label-width="100px" class="user-form">
                <el-form-item label="发票类型" show-message prop="type">
                    <el-select filterable v-model="ruleForm.type" clearable placeholder="请选择" class="select-w2" @change="choicetype">
                        <el-option v-for="i in type" :key="i.value" :label="i.label" :value="i.value"></el-option>
                    </el-select>
                </el-form-item>
                <div v-if="ruleForm.type&&ruleForm.type!=0">
                    <el-form-item label="发票领取方式" show-message prop="collectionMethod" v-if="ruleForm.type != 3">
                    <el-select filterable v-model="ruleForm.collectionMethod" clearable placeholder="请选择" class="select-w2">
                        <el-option v-for="i in collectionMethod" :key="i.value" :label="i.label" :value="i.value"></el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="发票抬头" show-message prop="invoiceTitle">
                        <el-input v-model="ruleForm.invoiceTitle"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" show-message prop="taxpayerIdentificationNumber">
                        <el-input v-model="ruleForm.taxpayerIdentificationNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="公司地址" show-message prop="address">
                        <el-input v-model="ruleForm.address"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" show-message prop="phone">
                        <el-input v-model="ruleForm.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行" show-message prop="accountBank">
                        <el-input v-model="ruleForm.accountBank"></el-input>
                    </el-form-item>
                    <el-form-item label="账号" show-message prop="accountNumber">
                        <el-input v-model="ruleForm.accountNumber"></el-input>
                    </el-form-item>
                    <el-form-item label="收件地址" show-message prop="recipientAddress" v-if="ruleForm.collectionMethod == 2 && ruleForm.type!=3">
                        <el-input  type="textarea" v-model="ruleForm.recipientAddress" placeholder="如果需要邮寄发票，清填写收件信息"></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱" show-message prop="invoiceEmail" v-if="ruleForm.type == 3">
                        <el-input v-model="ruleForm.invoiceEmail"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" show-message prop="remark">
                        <el-input  type="textarea" v-model="ruleForm.remark"></el-input>
                    </el-form-item>
                </div>
                
                <div class="submit">
                    <el-button size="medium" round type="primary" @click="save">保存</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import http from '@/utils/http'
import apis from '@/utils/apis'
    export default {
        name: "invoice",
        data() {
            return {
                ruleForm: {
                  type: '',
                  collectionMethod: '',
                  invoiceTitle: '',
                  taxpayerIdentificationNumber: '',
                  address: '',
                  phone: '',
                  accountBank: '',
                  accountNumber: '',
                  recipientAddress: '',
                  invoiceEmail: '',
                  remark: ''
                },
                rules: {
                    type: [{ required: true, message: '请输入发票类型', trigger: 'blur' }],
                    collectionMethod: [{ required: true, message: '请选择发票领取方式', trigger: 'blur' }],
                    invoiceTitle: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
                    taxpayerIdentificationNumber: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
                    address: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
                    phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
                    accountBank: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
                    recipientAddress: [{ required: true, message: '请输入收件地址', trigger: 'blur' }],
                    invoiceEmail: [
                        { required: true, message: '请输入电子邮箱', trigger: 'blur' },
                         { pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/, message: '邮箱格式有误', trigger: 'blur' }
                        ],
                    accountNumber: [{ required: true, message: '请输入账号', trigger: 'blur' }]
                },
                type: [
                    {
                      value: 0,
                      label: '未填写'
                    },
                    {
                      value: 1,
                      label: '增值税普通发票'
                    },
                    {
                      value: 2,
                      label: '增值税专用发票'
                    },
                    {
                      value: 3,
                      label: '增值税电子普通发票'
                    }
                ],
                collectionMethod: [
                    {
                        value: 1,
                        label: '现场领取'
                    },
                    {
                        value: 2,
                        label: '发票邮寄'
                    }
                ],
                isedit: false,
                invoiceId: ''
            }
        },
        methods: {
            //选择发票类型
            choicetype(_val) {
                if(_val == 2) { // 增值税专用发票
                    this.rules.address[0].required = true
                    this.rules.phone[0].required = true
                    this.rules.accountBank[0].required = true
                    this.rules.accountNumber[0].required = true
                } else { // 其他
                    this.rules.address[0].required = false
                    this.rules.phone[0].required = false
                    this.rules.accountBank[0].required = false
                    this.rules.accountNumber[0].required = false
                }
            },
            save() {
                // const data = this.ruleForm
                this.$refs['ruleForm'].validate(async (valid) => {
                    if (valid) {
                        console.log('提交成功')
                        this.editInvoice()
                        // if(!this.isedit){
                        //   this.editInvoice()
                        // }
                    } else {
                        this.$alert('请填写完整', '',{
                          showClose: false
                        })
                        return false;
                    }
                })
            },
            // 发票信息
            async getInvoice(){
            //   console.log('this.user',this.user)
              let params={
                audienceId:localStorage.getItem('audienceId')
              }
              this.id=localStorage.getItem('meetingId')
              console.log('this.meetingId',this.meetingId)
              const res = await http.get(`${apis.getEditInvoice}/${this.meetingId}`,{params})
              console.log('发票信息',res)
              if(res.code==0){
                 if(res.invoice!==null){
                    // 赋值
                    this.ruleForm = res.invoice
                    if(res.invoice.id){
                         this.invoiceId = res.invoice.id
                    }
                    if(this.ruleForm.type === 0){
                        this.isedit = true
                    }else{
                        this.isedit = false
                    }
                    // this.choicetype(this.ruleForm.type)
                 }else{
                   this.isedit = false
                 }
                 
              }
              this.getInvoiceConfig()
            }, 
            async editInvoice(){
              const params={
                "accountBank": "",
                "accountNumber": "",
                "address": "",
                "audienceId": 0,
                "collectionMethod": 0,
                "invoiceEmail": "",
                "invoiceTitle": "",
                "meetingId": 0,
                "phone": "",
                "recipientAddress": "",
                "remark": "",
                "taxpayerIdentificationNumber": "",
                "type": 1,
              }
              if(this.invoiceId) {
                  params.id = this.invoiceId
              }
              this.id=localStorage.getItem('meetingId')
              console.log('this.meetingId',this.meetingId)
              this.ruleForm.meetingId=this.id
              this.ruleForm.audienceId=localStorage.getItem('audienceId')

                console.log('发票值',this.ruleForm)
              const res = await http.post(`${apis.setInvoice}`,this.ruleForm)
              if(res.code === 0) {
                  this.$alert('修改成功', '',{
                    showClose: false
                  })
              }else{
                  this.$alert(res.msg, '',{
                    showClose: false
                  })
              }
            },
            async getInvoiceConfig() {
               const res = await http.get(`/renren-fast/app/audience/invoiceConfigInfo/${this.meetingId}`)
               const invoiceType = res.invoiceConfig.invoiceType.split('-')
               const receiveType = res.invoiceConfig.receiveType.split('-')
               this.type=[{
                 value: 0,
                 label:'未填写'
               }]
               console.log(res.invoiceConfig.invoiceType)
               if(res.invoiceConfig.invoiceType){
                  const type=invoiceType.map(ele=>{
                      return {
                          value: ele,
                          label: ele == 1? '增值税普通发票': ele == 2?'增值税专用发票':ele == 3?'增值税电子普通发票':'未填写'
                      }
                  })
                  this.type=[...this.type, ...type]
               }
               if(res.invoiceConfig.receiveType){
                  this.collectionMethod = receiveType.map(ele=>{
                      return {
                          value: ele,
                          label: ele==1?'现场领取':ele==2?'发票邮寄':''
                      }
                  })
               }
               
               this.choicetype(this.ruleForm.type)
            }
        },
        computed:{
            meetingId() {
                return this.$store.state.meetingId || localStorage.getItem('meetingId')
            }
        },
        created () {
            // this.user= JSON.parse(localStorage.getItem('userinfo'))
            this.getInvoice()
            // this.getInvoiceConfig()
        }
    }
</script>

<style lang="stylus" scoped>
.el-select-dropdown__item
            padding 15px 0
            box-sizing content-box
            font-size 28px
.back-btn{
    color: #606060
    font-size 27px
    padding 10px
}
.invoice-box
    width 100%
    background-color #fff;
    min-height 100vh
    box-sizing border-box
    .user-form
        /deep/ .el-form-item__error
            font-size 28px
    .user
        background #ffffff
        margin-top 30px
        padding 26px 20px
        .user-title
            font-size 32px
            padding-bottom 18px
            border-bottom 1px dashed rgba(199,199,199,1)
        .user-form
            margin-top 20px
            font-size 32px
            /deep/ .el-form-item__label
                font-size 36px
                padding-bottom 18px
            /deep/ .el-input__inner
                height 80px
                line-height 80px
                font-size 32px
            /deep/ .el-form-item
                margin-bottom 31px

    .select-w
        width 347px
        height 60px
    .select-w2
        width 710px
        margin-top 20px
    .select
        margin 0px 15px 15px 0px
    .adress
        margin-top 10px
    /deep/ .el-checkbox__inner
        width 20px
        height 20px
    /deep/ .el-checkbox__label
        font-size 28px
    /deep/ .el-radio__inner
        width 20px
        height 20px
    /deep/ .el-textarea__inner {
      font-size: 30px;
    }

    .submit
        display flex
        justify-content center
        /deep/ .el-button--medium
            width 300px
            height 60px
            border-radius 10px
            box-sizing content-box
            font-size 30px
            background-color #2852a6
            border-color #2852a6
  @media screen and (min-width: 800px)
        .back-btn{
            font-size 24px
            margin-bottom 20px
            margin-left 20px
        }
        .el-select-dropdown__item {
            padding: 0;
            box-sizing: content-box;
            font-size: 22px;
            height: 3vw;
            line-height: 3vw;
            font-size: 20px;
            padding-left: 26px;
        }
        .invoice-box
            width: 900px;
            margin: 0 auto;
            background-color #fff;
            min-height 100vh
            box-sizing border-box
            .user-form
                /deep/ .el-form-item__error
                    font-size 28px
            .user
                background #ffffff
                margin-top 30px
                padding 26px 20px
                .user-title
                    font-size 32px
                    padding-bottom 18px
                    border-bottom 1px dashed rgba(199,199,199,1)
                .user-form
                    margin-top 20px
                    font-size 32px
                    /deep/ .el-form-item__label
                        font-size 36px
                        padding-bottom 0px
                    /deep/ .el-input__inner
                        height 80px
                        line-height 80px
                        font-size 32px
                    /deep/ .el-form-item
                        margin-bottom 31px

            .select-w
                width 347px
                height 60px
            .select-w2
                width 710px
                margin-top 0px
            .select
                margin 0px 15px 15px 0px
            .adress
                margin-top 10px
            /deep/ .el-checkbox__inner
                width 20px
                height 20px
            /deep/ .el-checkbox__label
                font-size 28px
            /deep/ .el-radio__inner
                width 20px
                height 20px

            .submit
                display flex
                justify-content center
                /deep/ .el-button--medium
                    width 300px
                    height 60px
                    border-radius 10px
                    box-sizing content-box
                    font-size 30px
                    background-color #2852a6
                    border-color #2852a6

</style>
